'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useState } from 'react'
import { Button } from '@components/common/AutoWidgetButton/button'
import BusinessModals from '@components/BusinessModal/businessModals'
import { sendEnterpriseEvent } from '@utils/enterpriseSegmentEvent'
import { EVENT_TYPE, TAP_EVENT, VIEW_LEAD_GEN_POPUP } from '@constants/enterpriseSegmentData'
import styles from './businessStickyFooter.module.scss'

const BusinessStickyFooter = ({ data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    if (isModalOpen) {
      sendEnterpriseEvent({ view_name: VIEW_LEAD_GEN_POPUP }, EVENT_TYPE.VIEW)
    }
  }, [isModalOpen])

  return (
    <div className={styles.main}>
      <div className={styles.texts}>
        <div className={styles.heading}>{data?.data?.attributes?.heading}</div>
        <div className={styles.subHeading}>{data?.data?.attributes?.subHeading}</div>
      </div>
      <div className={styles.getInTouchButton}>
        <Button onClick={() => {
          sendEnterpriseEvent({ action_name: data?.data?.attributes?.buttonText, view_name: VIEW_LEAD_GEN_POPUP, action_type: TAP_EVENT.TAP_LEAD_GEN_POPUP })
            setIsModalOpen(true)
          }}
          ctaText={data?.data?.attributes?.buttonText} />
        <BusinessModals isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} content={data?.data?.attributes?.formSnippet}/>
      </div>
    </div>
  )
}

export default BusinessStickyFooter
